import React, { Component } from 'react';
import CancelarPage from './cancelar.page';
import HistologiaApi from '../../histologia.api';

class CancelarContainer extends Component {
    cancelarItem(){
        if(this.props.item.etapa === 1){
            HistologiaApi.cancelarBloco(this.props.item.id).then((result) => {
                this.props.toggle();
            });
        } else {
            HistologiaApi.cancelarLamina(this.props.item.id).then((result) => {
                this.props.toggle();
            });
        }
    }

    render() {
        return <CancelarPage
            open={this.props.open}
            toggle={this.props.toggle}
            item={this.props.item}
            cancelarItem={this.cancelarItem.bind(this)}
        ></CancelarPage>
    }
}

export default CancelarContainer


// WEBPACK FOOTER //
// ./src/pages/histologia/common/modais/cancelar/cancelar.container.js